import axios from "axios";
import moment from "moment";
import notify from "devextreme/ui/notify";
import { alert } from "devextreme/ui/dialog";
const baseUri = "WebApi.asmx/api/applicationService";
const store = {};
const mutations = {
    DELETE_DOCUMENT(state, { data, img }) {
        data.Value = data.Value.filter((m) => m.TfiId != img.TfiId);
    },
    SAVE_GENERICFORMDATA() { },
    SUBMIT_APPLICATION() { },
    GET_TOPIC_VERSION_CHANGES(state, posts) {
        state.topicVersionChanges = posts.changes ? posts.changes : [];
        // Apply version changes to existing form elements if they are already loaded
        if (
            state.modulTypeAttributeList &&
            state.modulTypeAttributeList.length > 0
        ) {
            methods.applyVersionChangesToFormElements(state);
        }
    },
    GET_RECENT_TOPIC_CHANGES(state, posts) {
        state.recentTopicChanges = posts.topics ? posts.topics : [];
        state.recentTopicChangesMessage = posts.message || "";
        state.recentTopicChangesDaysBack = posts.daysBack || 14;
        state.recentTopicChangesFromDate = posts.fromDate || "";
        state.recentTopicChangesToDate = posts.toDate || "";
    },
    APPLY_VERSION_CHANGES_TO_FORM_ELEMENTS(state) {
        methods.applyVersionChangesToFormElements(state);
    },
    GET_GENERIC_FORM_DATA_GROUPED(state, posts) {
        state.regions = [];
        state.modulTypeAttributeList = [];
        state.modulTypeAttributeListGrouped = posts.formElementsGroupedByRegion
            ? posts.formElementsGroupedByRegion
            : [];
        state.modulTypeAttributeListGrouped.forEach((p) =>
            p.ModulGroups.forEach((r) => {
                state.regions.push(r);
                state.isAdmin = posts.isAdmin;
                state.ownerUsrId = posts.OwnerUsrId;
                r.visible = false;
                r.FormElements.forEach((m) => {
                    state.modulTypeAttributeList.push(m);
                    if (m.ToolTip === "") {
                        if (m.Description) {
                            m.ToolTip = m.Description.replace(/<[^>]+>/g, "");
                        }
                    } else {
                        if (m.ToolTip) {
                            m.ToolTip = m.ToolTip.replace(/<[^>]+>/g, "");
                        }
                    }
                    m.ShowSelectionPopup = false;
                    m.groupData = methods.processGrouped(m);
                    var expand = m.groupData.length < 5;
                    if (expand) {
                        m.groupData.forEach((g) => (g.expand = true));
                    }
                    m.hasFocus = false;
                    m.uploadChanged = false;
                    m.oldValue = m.Value;
                    m.RequiredMessage = m.Caption + " is required";
                    if (m.AtyId == 19) {
                        m.MinFilesCount = m.Required ? 1 : 0;
                        m.MaxFilesCount = m.MatMaxFiles > 0 ? m.MatMaxFiles : 1;
                        if (m.MinFilesCount > 0 && m.AtyId == 19) {
                            m.RangeMessage =
                                m.MaxFilesCount == 1
                                    ? m.RequiredMessage
                                    : m.Caption +
                                    " must be between " +
                                    m.MinFilesCount +
                                    " and " +
                                    m.MaxFilesCount +
                                    " files";
                        }
                    }
                    if (m.AtyId == 14 || m.AtyId == 21) {
                        m.MinLength = m.MinLength > 0 ? m.MinLength : m.Required ? 1 : 0;
                        m.MaxLength =
                            m.MaxLength >= m.MinLength ? m.MaxLength : m.MinLength;
                        if (m.MinLength > 0) {
                            m.RangeMessage =
                                m.MaxLength == 1
                                    ? m.RequiredMessage
                                    : m.Caption +
                                    ": select between " +
                                    m.MinLength +
                                    " and " +
                                    m.MaxLength +
                                    " entries";
                        }
                    }
                    m.allowedFileTypes = "";

                    if (m.Caption.startsWith("Company Logo")) {
                        m.allowedFileTypes = "SVG, EPS, or AI";
                        m.Caption = "Company Logo";
                    } else if (m.Caption.startsWith("Pitch")) {
                        m.allowedFileTypes = "PDF or PPTX";
                    } else if (m.Caption.startsWith("Video")) {
                        m.allowedFileTypes = "MP4, MOV, WEBM, or OGV - max. 100 MB";
                    }
                });
            })
        );

        state.ttyInfo = state.ttyInfo = posts?.ttyInfo ?? null;
        {
            const endMs = posts?.ttyInfo?.TtyEnd
                ? moment(posts.ttyInfo.TtyEnd).valueOf()
                : NaN;
            state.roundIsOpen = Number.isFinite(endMs) && Date.now() <= endMs;
        }
        state.formIsReadOnly = posts.ReadOnly;
        state.currentTopicId = posts.topicId;
        state.showVoting = posts.ShowVoting;
        state.allowPublicVoting = posts.publicVotingConfig.AllowVoting;
        state.publicVotingRtgId = posts.publicVotingConfig.RtgId;
        state.rtgId = posts.RtgId;
        state.ttyId = posts.ttyId;
        state.topicInfo.topicId = posts.topicId;
        state.topicId = posts.topicId;
        state.topicInfo.schaltzeitId = posts.schaltzeitId;
        state.topicInfo.title = posts.title;
        state.topicInfo.OwnerUsrId = posts.OwnerUsrId;
        state.topicInfo.UsrLastName = posts.UsrLastName;
        state.topicInfo.UsrFirstName = posts.UsrFirstName;
        state.topicInfo.PriName = posts.PriName;
        state.topicInfo.PriId = posts.PriId;
        state.topicInfo.TpcHasAmbassedor = posts.TpcHasAmbassedor;
        state.TpcFullfillment = posts.TpcFullfillment;

        state.topicIdList = posts.TopicIdList ? posts.TopicIdList : [];
    },
    GET_GENERIC_FORM_DATA(state, posts) {
        state.modulTypeAttributeList = posts.formElements ? posts.formElements : [];
        state.modulTypeAttributeList.forEach((m) => {
            if (m.ToolTip == "") {
                m.ToolTip = m.Description;
            }
            m.oldValue = m.Value;
            m.RequiredMessage = m.Caption + " is required";
            if (m.AtyId == 19) {
                m.MinFilesCount = m.Required ? 1 : 0;
                m.MaxFilesCount = m.MatMaxFiles > 0 ? m.MatMaxFiles : 1;
                if (m.MinFilesCount > 0 && m.AtyId == 19) {
                    m.RangeMessage =
                        m.MaxFilesCount == 1
                            ? m.RequiredMessage
                            : m.Caption +
                            " must be between " +
                            m.MinFilesCount +
                            " and " +
                            m.MaxFilesCount +
                            " files";
                }
            }
            if (m.AtyId == 14 || m.AtyId == 21 || m.AtyId == 24) {
                m.MinLength = m.MinLength > 0 ? m.MinLength : m.Required ? 1 : 0;
                m.MaxLength = m.MaxLength >= m.MinLength ? m.MaxLength : m.MinLength;
                if (m.MinLength > 0) {
                    m.RangeMessage =
                        m.MaxLength == 1
                            ? m.RequiredMessage
                            : m.Caption +
                            ": select between " +
                            m.MinLength +
                            " and " +
                            m.MaxLength +
                            " entries";
                } else {
                    m.RangeMessage = m.Required ? m.RequiredMessage : "";
                }
            }
        });

        state.ttyInfo = posts.ttyInfo ? posts.ttyInfo : [];
        state.formIsReadOnly = posts.ReadOnly;
        state.currentTopicId = posts.topicId;
        state.showVoting = posts.ShowVoting;
        state.allowPublicVoting = posts.publicVotingConfig.AllowVoting;
        state.publicVotingRtgId = posts.publicVotingConfig.RtgId;
        state.rtgId = posts.RtgId;
        state.ttyId = posts.ttyId;
        state.topicInfo.topicId = posts.topicId;
        state.topicId = posts.topicId;
        state.topicInfo.schaltzeitId = posts.schaltzeitId;
        state.topicInfo.title = posts.title;
        state.topicInfo.OwnerUsrId = posts.OwnerUsrId;
        state.topicInfo.UsrLastName = posts.UsrLastName;
        state.topicInfo.UsrFirstName = posts.UsrFirstName;
        state.topicInfo.TpcHasAmbassedor = posts.TpcHasAmbassedor;

        state.topicIdList = posts.TopicIdList ? posts.TopicIdList : [];
    },
    loadingStatus(state, posts) {
        state.loadingStatus = posts;
    },
};
const state = {
    modulTypeAttributeList: [],
    topicInfo: { title: "", schaltzeitId: "", topicId: 0 },
    loadingStatus: false,
    formIsReadOnly: false,
    topicIdList: [],
    currentTopicId: 0,
    topicId: 0,
    rtgId: 0,
    ttyInfo: [],
    topicVersionChanges: [],
    recentTopicChanges: [],
    recentTopicChangesMessage: "",
    recentTopicChangesDaysBack: 14,
    recentTopicChangesFromDate: "",
    recentTopicChangesToDate: "",
    versionStatus: "",
    currentStatus: "",
};
const getters = {
    loadingStatus(state) {
        return state.loadingStatus;
    },
};
const methods = {
    processGrouped(data) {
        var list = data.SelectBoxItems;
        switch (data.AtyId) {
            case 14:
            case 20:
            case 21:
                break;
            default:
                return data.listItems ? data.listItems : [];
        }
        if (data.listItems) {
            return data.listItems;
        }
        var selectedKeys = data.SelectedKeys;
        var allItems = [];
        var result = list
            .filter((m) => {
                return m.ParentValue == null || m.ParentValue == "";
            })
            .map((m) => {
                var ele1 = {
                    value: m.Value,
                    parentValue: m.ParentValue,
                    items: m.Items.map((i) => {
                        var ele2 = {
                            value: i.Value,
                            parentValue: i.ParentValue,
                            text: i.Text,
                            expand: false,
                            selected: selectedKeys.indexOf(i.Value) >= 0,
                            item: i,
                        };
                        allItems.push(ele2);
                        return ele2;
                    }),
                    text: m.Text,
                    selected: false,
                };
                return ele1;
            });
        data.listItems = result;
        data.allItems = allItems;
        return result;
    },

    applyVersionChangesToFormElements(state) {
        if (
            !state.topicVersionChanges ||
            !state.topicVersionChanges.length ||
            !state.modulTypeAttributeList
        ) {
            state.modulTypeAttributeList.forEach(formElement => {
                formElement.CurrentVersionValue = "same as current Version";
            })
            return;
        }
        var statusChange = state.topicVersionChanges.find(change => change.FieldName == "StatusChange")
        if (statusChange) {
            state.versionStatus = statusChange.VersionStatus;
            state.currentStatus = statusChange.CurrentStatus;
        }
        else {
            state.versionStatus = "";
            state.currentStatus = "";
        }
        state.modulTypeAttributeList.forEach((formElement) => {
            // Find corresponding change in version changes by field name
            const versionChange = state.topicVersionChanges.find(
                (change) => change.FieldName === formElement.Name
            );

            if (versionChange) {
                formElement.CurrentVersionValue = versionChange.NewValue;
                formElement.PreviousVersionValue = versionChange.OldValue;
                formElement.ChangeType = versionChange.ChangeType;
                formElement.ComparisonTime = versionChange.ComparisonTime;
                formElement.HasVersionChange = true;
                if (!formElement.PreviousVersionValue) {
                    formElement.PreviousVersionIsNull = true;
                }
            } else {
                formElement.CurrentVersionValue = "same as current Version";
            }
        });
    },
};
const watch = {};
const actions = {
    GetGenericFormDataGrouped({ commit }, data) {
        // Only set loading status if not called from combined action
        if (!data._skipLoadingStatus) {
            commit("loadingStatus", true);
        }
        if (!data.version) {
            return actions.GetGenericFormData({ commit }, data)
        }
        
        var formData = new FormData();
        formData.append("rfeId", data.rfeId);
        formData.append("ttyId", data.ttyId);
        formData.append("topicId", data.topicId);
        formData.append("rouId", data.rouId);
        formData.append("cmd", data.cmd);
        formData.append("args", data.args);
        formData.append("version", data.version);

        return axios
            .post(baseUri + "/GetGenericFormDataGrouped", formData)
            .then((res) => {
                if (res.data.success) {
                    commit("GET_GENERIC_FORM_DATA_GROUPED", res.data);
                    if (!data._skipLoadingStatus) {
                        commit("loadingStatus", false);
                    }
                } else {
                    if (res.data.argsNotFound) {
                        window.location = "NavigateLocal.asmx?action=logout";
                    }
                }
                return res;
            });
    },

    ApplyVersionChangesToFormElements({ commit }) {
        commit("APPLY_VERSION_CHANGES_TO_FORM_ELEMENTS");
    },

    async GetGenericFormDataGroupedWithVersionChanges(
        { commit, dispatch },
        data
    ) {
        commit("loadingStatus", true);

        try {
            // First load the form data (skip loading status since we manage it here)
            const formDataWithSkip = { ...data, _skipLoadingStatus: true };
            const formDataResponse = await dispatch(
                "GetGenericFormDataGrouped",
                formDataWithSkip
            );

            // Then load version changes if form data was successful
            if (formDataResponse.data.success) {
                await dispatch("GetTopicVersionChanges", {
                    ...data,
                    _skipLoadingStatus: true,
                });

                // Version changes are automatically applied in GET_TOPIC_VERSION_CHANGES mutation
                // since modulTypeAttributeList is now loaded
            }

            commit("loadingStatus", false);
            return formDataResponse;
        } catch (error) {
            commit("loadingStatus", false);
            throw error;
        }
    },

    GetTopicVersionChanges({ commit }, data) {
        // Only set loading status if not called from combined action
        if (!data._skipLoadingStatus) {
            commit("loadingStatus", true);
        }
        var formData = new FormData();

        formData.append("args", data.args);
        formData.append("version", data.version);
        return axios
            .post(baseUri + "/GetTopicVersionChanges", formData)
            .then((res) => {
                if (res.data.success) {
                    commit("GET_TOPIC_VERSION_CHANGES", res.data);
                    if (!data._skipLoadingStatus) {
                        commit("loadingStatus", false);
                    }
                } else {
                    if (res.data.argsNotFound) {
                        window.location = "NavigateLocal.asmx?action=logout";
                    }
                }
                return res;
            });
    },
    GetRecentTopicChanges({ commit }, data) {
        // Only set loading status if not called from combined action
        if (!data._skipLoadingStatus) {
            commit("loadingStatus", true);
        }
        var formData = new FormData();

        // Optional parameter for days back (default is 14 days in backend)
        if (data.daysBack) {
            formData.append("daysBack", data.daysBack);
            formData.append("isTlt", data.isTlt);
        }

        return axios
            .post(baseUri + "/GetRecentTopicChanges", formData)
            .then((res) => {
                if (res.data.success) {
                    commit("GET_RECENT_TOPIC_CHANGES", res.data);
                    if (!data._skipLoadingStatus) {
                        commit("loadingStatus", false);
                    }
                } else {
                    notify(
                        res.data.message || "Error loading recent topic changes",
                        "error"
                    );
                    if (!data._skipLoadingStatus) {
                        commit("loadingStatus", false);
                    }
                }
                return res;
            })
            .catch((error) => {
                notify("Error loading recent topic changes: " + error.message, "error");
                if (!data._skipLoadingStatus) {
                    commit("loadingStatus", false);
                }
                throw error;
            });
    },
    GetGenericFormData({ commit }, data) {
        // Only set loading status if not called from combined action
        if (!data._skipLoadingStatus) {
            commit("loadingStatus", true);
        }
        var formData = new FormData();
        formData.append("rfeId", data.rfeId);
        formData.append("ttyId", data.ttyId);
        formData.append("topicId", data.topicId);
        formData.append("rouId", data.rouId);
        formData.append("cmd", data.cmd);
        formData.append("args", data.args);
        return axios.post(baseUri + "/GetGenericFormData", formData).then((res) => {
            if (res.data.success) {
                commit("GET_GENERIC_FORM_DATA", res.data);
                if (!data._skipLoadingStatus) {
                    commit("loadingStatus", false);
                }
            } else {
                if (res.data.argsNotFound) {
                    window.location = "NavigateLocal.asmx?action=logout";
                }
            }
            return res;
        });
    },
    DeleteTopicFile({ commit }, { args, img, data }) {
        var formData = new FormData();
        formData.append("TfiId", img.TfiId);
        formData.append("MatId", data.MatId);
        formData.append("args", args);
        axios.post(baseUri + "/DeleteDocument", formData).then((res) => {
            if (res.data.success) {
                commit("DELETE_DOCUMENT", { data, img });
            }
        });
    },
    SaveGenericFormData({ commit }, { submit, args }) {
        var store = this.state.applicationStore;
        submit = submit ? submit : false;
        var val = store.modulTypeAttributeList;
        var data = val; // val.filter((p) => p.Value !== p.oldValue)
        var updateData = data.map((m) => {
            return {
                MatId: m.MatId,
                Name: m.Name,
                Value: m.Value,
                SelectedKeys: m.SelectedKeys,
                Visible: m.Visible,
            };
        });
        var formData = new FormData();
        formData.append("data", JSON.stringify(updateData));
        formData.append("topicId", store.topicId);
        formData.append("submit", submit);
        formData.append("args", args);
        return axios
            .post(baseUri + "/SaveGenericFormData", formData)
            .then((res) => {
                if (res.data.success == true) {
                    notify("Information has been successfully saved.");
                    commit("SAVE_GENERICFORMDATA");
                } else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    SubmitApplication(
        { commit },
        { topicId, statusId, fullfillmentNo, submitToast }
    ) {
        var formData = new FormData();
        formData.append("topicId", topicId);
        formData.append("statusId", statusId);
        formData.append("fullfillmentNo", fullfillmentNo);
        return axios
            .post(baseUri + "/SubmitMyApplication", formData)
            .then((res) => {
                if (res.data.success == true) {
                    notify(submitToast);
                    commit("SUBMIT_APPLICATION");
                } else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
};

export default {
    state,
    store,
    mutations,
    getters,
    actions,
    methods,
    watch,
};
